import { PartialObject } from 'lodash';
import { MemberInsuranceNode, ProviderCertificationNode } from './../../../generated/webapp_gql';

import {
    CareRecommendationNode,
    CrisisProviderCompanyAssignmentNode,
    CrisisProviderCountryAssignmentNode,
    Phq9Access,
    FeaturedBenefit,
} from 'src/generated/webapp_gql';
import { ValidateTokenData } from 'src/modules/auth/models/auth';

import { CompanyAdditionalBenefitFragment } from 'src/modules/benefits/documents/getCompanyAdditionalBenefitsQuery.generated';

export interface RegisteredUserInfo {
    firstName: string;
    id: number;
    uuid: string;
    lastName: string;
    email: string;
}

export interface UserProfileSettingsDetails extends PartialObject<UserDetails> {
    avatarFile: File | null;
}

export enum Role {
    MEMBER = 'MEMBER',
    COACH = 'COACH',
    SYSTEM_ADMINISTRATOR = 'SYSTEM_ADMINISTRATOR',
}

export enum ProviderType {
    COACH = 'Coach',
    THERAPIST = 'Therapist',
    MENTAL_HEALTH_COACH = 'Mental_Health_Coach',
    PSYCHIATRIST = 'Psychiatrist',
}

export enum SOURCE_TYPES {
    PRE_ONBOARDING = 'Pre Onboarding',
    POST_ONBOARDING = 'Post Onboarding',
    HOME_PAGE = 'Home Page',
    SETTINGS = 'Settings',
    PHQ_9_LINK = 'PHQ-9 Link',
    PHQ_9_ENDORSEMENTS = 'PHQ-9 Endorsements',
    TAKEOVER_SCREEN = 'Takeover Screen',
    CALLBACK_SCREEN = 'Callback Screen',
}

export enum REGISTRATION_SOURCES {
    MAGIC_LINK = 'Magic Link',
    ORGANIC_REGISTRATION = 'Organic Registration',
    DEPENDENT_INVITATION = 'Dependent Invitation',
    SINGLE_SIGN_ON = 'Single Sign On',
    SCIM = 'SCIM Provisioning',
}

export interface CrisisEvent {
    platform: string;
    source: string;
}

export interface UserDetails extends RegisteredUserInfo {
    avatar: string | null;
    company: string;
    companyUuid: string;
    companyBenefitsPageSubheading: string | null;
    companySsoOnly: boolean;
    username: string;
    zipCode: string;
    state: string;
    mailingAddress: string;
    phoneNumber: string;
    mobileAppUsed: boolean; // TODO(Michal): Make sure that this field gets added to the backend
    birthDate: string | null;
    newEmailAddressNotConfirmed: string | null;
    localTimezone: string;
    languagePreferences: string[];
    parentUuid: string | null;
    isDependent: boolean;
    country: string;
    availability: string[];
    city: string;
    role: Role;
    defaultVisitDuration: number;
    eligiblePersonEmail: string | null;
    isActiveCobraRifMember: boolean;
    emailConfirmed: boolean;
    joinedAt: string;
    races?: string[];
    careRecommendations: CareRecommendationNode[];
    phq9Access?: Phq9Access;
    featuredBenefits?: FeaturedBenefit[];
    registrationSource: string;
    hpiEligibilityStatus: boolean;
    hpiMemberInsurance: MemberInsuranceNode | null;
    isCompanyHpiEnabled: boolean;
    isCompanyPsychiatryEnabled: boolean;
    sharedPreferences: SharedPreference[];
    notificationPreferences: NotificationPreferences;
    showCrisisModal?: boolean;
    crisisModalSource?: SOURCE_TYPES;
    ssoOnly: boolean;
}

export interface SharedPreference {
    key: SharedPreferencesKeys;
    value: string;
}

export enum SharedPreferencesKeys {
    DailyPauseRemindersPageVisited = 'DailyPauseRemindersPageVisited',
    CanBeBucketedForDPStreaks = 'CanBeBucketedForDPStreaks',
}

export interface UpdateUserInfoPayload extends UserDetails {
    password: string;
    oldPassword: string;
}

export interface ChangePasswordPayload {
    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}

export interface UserState extends UserDetails {
    companyAdditionalBenefits: CompanyAdditionalBenefitFragment[];
    providerCertifications: ProviderCertificationNode[];
    crisisProviderCompanyAssignments: CrisisProviderCompanyAssignmentNode[];
    crisisProviderCountryAssignments: CrisisProviderCountryAssignmentNode[];
}

export type NewEmailAddressConfirmTokenData = ValidateTokenData;

export enum CleverTapProxyNotificationCategories {
    DailyPauseRemindersEmail = 'dailyPauseRemindersEmail',
}

export interface NotificationPreferences {
    [CleverTapProxyNotificationCategories.DailyPauseRemindersEmail]: boolean;
}
